export default function validatePassword(password: string) {
  const value = password;
  const rule = /^(?=.*[a-zA-Z])(?=.*[0-9~₩!@#$%^&*()\-+_=[\]|\\{};:'".,?/]).{10,20}$/;
  let message = '';
  let success = false;

  if (!value) {
    message = '비밀번호 입력은 필수입니다.';
  } else if (/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(value)) {
    message = '한글은 입력할 수 없으니 영문으로 바꾸어 입력해 주세요.';
  } else if (/[^a-zA-Z0-9~₩!@#$%^&*()\-+_=[\]|\\{};:'".,?/]/.test(value)) {
    message = '사용할 수 없는 특수문자가 포함되어 있습니다.';
  } else if (!rule.test(value)) {
    message = '10자~20자 이내 영문 대소문자, 숫자 또는 특수문자 조합';
  } else {
    message = '';
    success = true;
  }

  return { success, message };
}
